module.exports = __webpack_public_path__ + "static/media/Bella-Terra-Bylaws.8dd4ac49.pdf";